import React, { Component } from 'react';
import {
  withStyles, 
  FormHelperText,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
  Slide,
  Divider,
} from '@material-ui/core';
import validator from "validator";
import { Auth, API } from "aws-amplify";
import cdialog from "../components/cdialog";
import { withTranslation } from "react-i18next";
import { saveLang, getSavedLang } from "../utils/lang";
import analytics from "../analytics";

const styles = (theme) => ({
  loginDialog: {
    maxWidth: "36rem",
    minWidth: "36rem",
    margin: "auto",
  },
  formContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  [theme.breakpoints.down("sm")]: {
    formContainer: {
      padding: "0 1rem",
    },
  },
  textField: {
    padding: ".75rem",
    borderRadius: "4px",
    backgroundColor: "#f5f5f5",
    border: "solid 1px #e5e5ea",
    marginBottom: ".25rem",
    fontSize: "0.875rem",
  },
  textFieldError: {
    padding: ".75rem",
    borderRadius: "4px",
    backgroundColor: "rgba(255, 23, 68, .05)",
    border: "solid 1px rgba(255, 23, 68, .5)",
    marginBottom: ".25rem",
    fontSize: "0.875rem",
  },
  button: {
    padding: ".875rem",
    marginTop: ".5rem",
  },
  dividerAuth: {
    marginTop: ".5rem",
    marginBottom: ".5rem",
  }
});

const Transition = (props) => {
    return <Slide direction="down" {...props} />;
  }
class LoginForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      isValidEmail: true,
      isValidPassword: true,
      requireMFA: false,
      mfaCode: "",
      isValidMfaCode: true,
      signInResponse: null
    };

    this.isValidEmail = this.isValidEmail.bind(this);
    this.isValidPassword = this.isValidPassword.bind(this);
    this.isValidMfaCode = this.isValidMfaCode.bind(this);
  }

  applyPreferredLangAndRedirect = async (history, onCheckoutPage, currUser) => {
    try {
      const email = (currUser && currUser.attributes && currUser.attributes.email) || this.state.email;
      let target = getSavedLang() || 'en';
      try {
        // Best-effort fetch from API; ignore failures (e.g., unauthenticated)
        const resp = await API.get('v2', `marketplace/users/by/email/${encodeURIComponent(email)}`);
        const pref = resp && resp.user && resp.user.preferredLang;
        if (typeof pref === 'string' && pref.toLowerCase().startsWith('fr')) target = 'fr';
      } catch (_) { /* ignore */ }
      try {
        // Persist cookie only; let app bootstrap pick it up to avoid re-entrant updates
        saveLang(target);
      } catch (_) { /* ignore */ }
    } catch (_) { /* guard */ }
    finally {
      // Full reload to ensure language is applied cleanly
      const target = getSavedLang() || 'en';
      const url = onCheckoutPage ? window.location.href : `/dashboard?lang=${target}`;
      window.location.assign(url);
    }
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };
  
  handleChangeEmail = (event) => {
    this.setState({
      [event.target.id]: String(event.target.value).toLowerCase(),
    });
  };

  isValidEmail(email) {
    const isValidEmail = validator.isEmail(email);
    this.setState({ isValidEmail });

    return isValidEmail;
  }

  isValidPassword(password) {
    const isValidPassword = !validator.isEmpty(password);
    this.setState({ isValidPassword });

    return isValidPassword;
  }

  isValidMfaCode(code) {
    const isValidMfaCode = !validator.isEmpty(code);
    this.setState({ isValidMfaCode });

    return isValidMfaCode;
  }

  isValidLogin(email, pw) {
    const isValidEmail = this.isValidEmail(email);
    const isValidPassword = this.isValidPassword(pw);
    return isValidEmail && isValidPassword;
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const { email, password } = this.state;
    const { t } = this.props;
    try {
      if (this.isValidLogin(email, password)) {
        this.setState({ isSubmitting: true });
        const { setUserNeedNewPassword, userHasAuthenticated, setUserAttributes, history } = this.props;
        const user = await Auth.signIn(email.toLowerCase().trim(), password);

        switch (user.challengeName) {
          case "NEW_PASSWORD_REQUIRED": {
            setUserNeedNewPassword(user);
            history.push("/new-password");
            break;
          }
          case "SMS_MFA": {
            this.setState({
              requireMFA: true,
              signInResponse: user,
              isSubmitting: false,
            });
            break;
          }
          default: {
            const currUser = await Auth.currentAuthenticatedUser();
            const currentRoute = this.props.match.path;
            const onCheckoutPage = currentRoute === "/seats/:slug/:gameId/:seatId";
            userHasAuthenticated(true);
            setUserAttributes(currUser);
            analytics.track("login_completed", {});
            this.setState({ isSubmitting: false });
            await this.applyPreferredLangAndRedirect(history, onCheckoutPage, currUser);
          }
        }
      }
    } catch (e) {
      switch (e.code) {
        case "NotAuthorizedException": {
          const msg = e.message.toLowerCase().includes("attempts exceeded")
          ? t("auth.login.errors.attemptsExceeded") 
          : <span dangerouslySetInnerHTML={{
              __html: `${t("auth.login.errors.invalid")}<a href="${t("signUp.phoneNumber")}" style="color: #2196f3; text-decoration: none;">${t("signUp.phoneNumber")}</a>${t("auth.login.errors.orEmail")}<a href="mailto:tix@fansfirst.ca" style="color: #2196f3; text-decoration: none;">tix@fansfirst.ca</a>${t("auth.login.errors.forAssistance")}`
            }} />;
          cdialog.error(t("auth.login.dialog.title"), msg);
          break;
        }
        case "UserNotFoundException": {
          cdialog.error(
            t("auth.login.dialog.title"),
            <span dangerouslySetInnerHTML={{
              __html: `${t("auth.login.errors.userNotFound")}<a href="/signup" style="color: #2196f3; text-decoration: none;">${t("auth.login.errors.signUp")}</a>${t("auth.login.errors.toCreate")}`
            }} />
          );
          break;
        }
        case "UserNotConfirmedException": {
          cdialog.error(
            t("auth.login.dialog.title"),
            t("auth.login.errors.userNotConfirm")
          );
          break;
        }
        case "PasswordResetRequiredException": {
          cdialog.error(
            t("auth.login.dialog.title"),
            t("auth.login.errors.passworNeedReset")
          );
          break;
        }
        default: {
          cdialog.error(
            t("auth.login.dialog.title"),
            <span dangerouslySetInnerHTML={{
              __html: `${t("auth.login.errors.invalid")}<a href="${t("signUp.phoneNumber")}" style="color: #2196f3; text-decoration: none;">${t("signUp.phoneNumber")}</a>${t("auth.login.errors.orEmail")}<a href="mailto:tix@fansfirst.ca" style="color: #2196f3; text-decoration: none;">tix@fansfirst.ca</a>${t("auth.login.errors.forAssistance")}`
            }} />
          );
        }
      }
      this.setState({ isSubmitting: false });
    }
  };

  confirmAuth = async () => {
    const { userHasAuthenticated, setUserAttributes, history, match } = this.props;
    const { signInResponse, mfaCode } = this.state;
    if (!this.isValidMfaCode(mfaCode)) {
      return;
    }
    const onCheckoutPage = match.path === "/seats/:slug/:gameId/:seatId";   
    this.setState({ isSubmitting: true });
    try {
      const response = await Auth.confirmSignIn( signInResponse, mfaCode, "SMS_MFA");
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      userHasAuthenticated(true);
      setUserAttributes(user);
      analytics.track("login_completed", {});

      this.setState({
        isSubmitting: false,
        requireMFA: false,
        signInResponse: null,
        mfaCode: "",
      });

      await this.applyPreferredLangAndRedirect(history, onCheckoutPage, user);
    } catch (e) {
      console.error("Error confirming authentication:", e);
      let errorMessage;
      switch (e.code) {
        case "NotAuthorizedException":
          errorMessage = "Invalid MFA code. Please try again.";
          break;
        case "CodeMismatchException":
          errorMessage = "Incorrect verification code. Please enter the correct code.";
          break;
        case "ExpiredCodeException":
          errorMessage = "The verification code has expired. Request a new code.";
          break;
        default:
          errorMessage = "An unexpected error occurred. Please try again.";
      }
      cdialog.error("Failed!", errorMessage);
      this.setState({
        isSubmitting: false,
        requireMFA: false,
        signInResponse: null,
        mfaCode: "",
      });
    }
  }

  renderForm() {
    const { classes, t, history } = this.props;
    const { isSubmitting, email, isValidEmail, password, isValidPassword, requireMFA, isValidMfaCode, mfaCode } = this.state;

    return (
      <form onSubmit={this.handleSubmit}>
        <TextField
          autoFocus={true}
          className={
            isValidEmail ? classes.textField : classes.textFieldError
          }
          disabled={isSubmitting || requireMFA}
          error={true}
          id="email"
          placeholder={t("auth.login.emailPlaceholder")}
          name="email"
          type="email"
          fullWidth={true}
          value={email}
          onChange={this.handleChangeEmail}
          margin="dense"
          InputProps={{
            disableUnderline: true,
          }}
        />
        {!isValidEmail && (
          <FormHelperText error={true}>
            {t("auth.login.emailError")}
          </FormHelperText>
        )}

        <TextField
          className={
            isValidPassword
              ? classes.textField
              : classes.textFieldError
          }
          disabled={isSubmitting || requireMFA}
          error={true}
          id="password"
          placeholder={t("auth.login.passwordPlaceholder")}
          name="password"
          type="password"
          fullWidth={true}
          value={password}
          onChange={this.handleChange}
          margin="dense"
          InputProps={{
            disableUnderline: true,
          }}
        />
        {!isValidPassword && (
          <FormHelperText error={true}>
            {t("auth.login.passwordError")}
          </FormHelperText>
        )}

        {requireMFA && (
          <>
            <Divider className={classes.dividerAuth} />
            <Typography>
              {t("accountVerification.sentInfo")}
            </Typography>
            <TextField
              className={
                isValidMfaCode
                  ? classes.textField
                  : classes.textFieldError
              }
              disabled={isSubmitting}
              error={true}
              id="mfaCode"
              placeholder={t("accountVerification.codePlaceholder")}
              name="mfaCode"
              type="number"
              fullWidth={true}
              value={mfaCode}
              onChange={this.handleChange}
              margin="dense"
              InputProps={{
                disableUnderline: true,
              }}
            />
          </>
        )}
        {!isValidMfaCode && (
          <FormHelperText error={true}>
            {t("accountVerification.codeRequired")}
          </FormHelperText>
        )}

        {requireMFA ? (
          <Button
            className={classes.button}
            color="primary"
            disabled={isSubmitting}
            variant="contained"
            fullWidth={true}
            onClick={this.confirmAuth}
          >
            {t("accountVerification.submit")}
          </Button>
        ) : (
          <Button
            className={classes.button}
            color="primary"
            disabled={isSubmitting}
            variant="contained"
            fullWidth={true}
            onClick={this.handleSubmit}
            type="submit"
          >
            {t("auth.login.submit")}
          </Button>
        )}
        <Button
          className={classes.button}
          color="secondary"
          disabled={isSubmitting}
          variant="text"
          fullWidth={true}
          onClick={() => history.push("/forgot-password")}
        >
          {t("auth.login.forgot")}
        </Button>
        <Typography variant="caption" color="textSecondary" align="center">
          <span dangerouslySetInnerHTML={{
            __html: `${t("auth.login.noAccount")}<a style="color: #2196f3; text-decoration: none;" href="/signup">${t("auth.login.signUpCta")}</a>`
          }} />
        </Typography>
      </form>
    );
  }

  render() {
    const { isOpen, handleClose, classes, t } = this.props;

    return (
      <Dialog 
        TransitionComponent={Transition}
        fullWidth={true}
        className={classes.loginDialog}
        open={isOpen} 
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{t("auth.login.title")}</DialogTitle>
        <DialogContent>
          <Grid
            className={classes.formContainer}
            container
            justify="center"
            alignItems="center"
          >
            <Grid item xs={12} md={12}>
              {this.renderForm()}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
}

export default withTranslation()(withStyles(styles)(LoginForm));
